module.exports = __webpack_public_path__ + "media/images/icons/outlined/tablet-d607b8f39c583a8116796a138c8e5076.svg";